import http from './api'

const route = '/analise/'

export default {
    listarAnalises: (produtorId, dataRecepcao, contratoId) => {
        return http.post(route + 'lista_analises', { produtor_id: produtorId, dataRecepcao: dataRecepcao, contrato_id: contratoId })
    },
    confirmaResultadoAnalise: (analiseId, idTanqueLeite, idProdutor, contratoId, nomeBd) => {
        return http.post(route + 'confirmaresultado', { id_analise: analiseId, id_tanqueleite: idTanqueLeite, id_produtor: idProdutor, contrato_id: contratoId, nomeBd: nomeBd })
    },
}
